import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { environment } from 'src/environments/environment.prod';
import { Services } from '../services/servicos';

@Component({
  selector: 'app-navegation',
  templateUrl: './navegation.component.html',
  styleUrls: ['./navegation.component.css']
})
export class NavegationComponent implements OnInit {

  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  menuNaoFaturamento: boolean = false;
  menuFinaneiro: boolean = false;
  menuNaoCarteira: boolean = false;
  menuNaoComercial: boolean = false;
  menuNaoTecnica: boolean = false;
  menuNaoCentral: boolean = false;
  // menuNaoVistoria: boolean = false;
  // menuNaoVistoriaManutencao: boolean = false;
  menuNaoLocalizacaoTecnico: boolean = false;
  // menuNaoLocalizacaoChamada: boolean = false;
  // menuNaoLocalizacaoClienteTecnico: boolean = false;
  // menuNaoLocalizacaoCliente: boolean = false;

  painel_faturamento: boolean = false;
  painel_financeiro: boolean = false;
  painel_carteira: boolean = false;
  painel_comercial: boolean = false;
  painel_tecnica: boolean = false;
  painel_central: boolean = false;
  painel_localizacao_tecnico: boolean = false;
  // painel_localizacao_chamada: boolean = false;
  // painel_localizacao_cliente_tecnico: boolean = false;
  // painel_localizacao_cliente: boolean = false;

  constructor(private service: Services,
    private router: Router) { }

  items: MenuItem[];
  version: string

  ngOnInit() {
    this.Rota();
    this.Menu();
    this.version = environment.version;
    console.log(this.router.url);
  }
  Rota() {
    if (this.router.url == '/faturamento') {
      this.menuNaoFaturamento = true;
      this.menuFinaneiro = false;
      this.menuNaoCarteira = false;
      this.menuNaoComercial = false;
      this.menuNaoTecnica = false;
      this.menuNaoCentral = false;
      // this.menuNaoVistoria = false;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = false;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    } else if (this.router.url == '/financeiro') {
      this.menuNaoFaturamento = false;
      this.menuFinaneiro = true;
      this.menuNaoCarteira = false;
      this.menuNaoComercial = false;
      this.menuNaoTecnica = false;
      this.menuNaoCentral = false;
      // this.menuNaoVistoria = false;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = false;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    } else if (this.router.url == '/carteira') {
      this.menuNaoFaturamento = false;
      this.menuFinaneiro = false;
      this.menuNaoCarteira = true;
      this.menuNaoComercial = false;
      this.menuNaoTecnica = false;
      this.menuNaoCentral = false;
      // this.menuNaoVistoria = false;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = false;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    } else if (this.router.url == '/comercial') {
      this.menuNaoFaturamento = false;
      this.menuFinaneiro = false;
      this.menuNaoCarteira = false;
      this.menuNaoComercial = true;
      this.menuNaoTecnica = false;
      this.menuNaoCentral = false;
      // this.menuNaoVistoria = false;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = false;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    } else if (this.router.url == '/tecnica') {
      this.menuNaoFaturamento = false;
      this.menuFinaneiro = false;
      this.menuNaoCarteira = false;
      this.menuNaoComercial = false;
      this.menuNaoTecnica = true;
      this.menuNaoCentral = false;
      // this.menuNaoVistoria = false;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = false;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    } else if (this.router.url == '/central') {
      this.menuNaoFaturamento = false;
      this.menuFinaneiro = false;
      this.menuNaoCarteira = false;
      this.menuNaoComercial = false;
      this.menuNaoTecnica = false;
      this.menuNaoCentral = true;
      // this.menuNaoVistoria = false;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = false;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    // } else if (this.router.url == '/vistoria') {
    //   this.menuNaoFaturamento = false;
    //   this.menuFinaneiro = false;
    //   this.menuNaoCarteira = false;
    //   this.menuNaoComercial = false;
    //   this.menuNaoTecnica = false;
    //   this.menuNaoCentral = false;
    //   this.menuNaoVistoria = true;
    //   this.menuNaoVistoriaManutencao = false;
    //   this.menuNaoLocalizacaoTecnico = false;
    //   this.menuNaoLocalizacaoChamada = false;
    //   this.menuNaoLocalizacaoClienteTecnico = false;
    //   this.menuNaoLocalizacaoCliente = false;
    // } else if (this.router.url == '/vistoria-manutencao') {
    //   this.menuNaoFaturamento = false;
    //   this.menuFinaneiro = false;
    //   this.menuNaoCarteira = false;
    //   this.menuNaoComercial = false;
    //   this.menuNaoTecnica = false;
    //   this.menuNaoCentral = false;
    //   this.menuNaoVistoria = false;
    //   this.menuNaoVistoriaManutencao = true;
    //   this.menuNaoLocalizacaoTecnico = false;
    //   this.menuNaoLocalizacaoChamada = false;
    //   this.menuNaoLocalizacaoClienteTecnico = false;
    //   this.menuNaoFaturamento = false;
    //   this.menuNaoLocalizacaoCliente = false;
    } else if (this.router.url == '/localizacao-tecnico') {
      this.menuNaoFaturamento = false;
      this.menuFinaneiro = false;
      this.menuNaoCarteira = false;
      this.menuNaoComercial = false;
      this.menuNaoTecnica = false;
      this.menuNaoCentral = false;
      // this.menuNaoVistoria = false;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = true;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    } 
    // else if (this.router.url == '/localizacao-chamada') {
    //   this.menuNaoFaturamento = false;
    //   this.menuFinaneiro = false;
    //   this.menuNaoCarteira = false;
    //   this.menuNaoComercial = false;
    //   this.menuNaoTecnica = false;
    //   this.menuNaoCentral = false;
    //   // this.menuNaoVistoria = false;
    //   // this.menuNaoVistoriaManutencao = false;
    //   this.menuNaoLocalizacaoTecnico = false;
    //   // this.menuNaoLocalizacaoChamada = true;
    //   // this.menuNaoLocalizacaoClienteTecnico = false;
    //   // this.menuNaoLocalizacaoCliente = false;

    // } else if (this.router.url == '/localizacao-cliente-tecnico') {
    //   this.menuNaoFaturamento = false;
    //   this.menuFinaneiro = false;
    //   this.menuNaoCarteira = false;
    //   this.menuNaoComercial = false;
    //   this.menuNaoTecnica = false;
    //   this.menuNaoCentral = false;
    //   // this.menuNaoVistoria = false;
    //   // this.menuNaoVistoriaManutencao = false;
    //   this.menuNaoLocalizacaoTecnico = false;
    //   // this.menuNaoLocalizacaoChamada = false;
    //   // this.menuNaoLocalizacaoClienteTecnico = true;
    //   // this.menuNaoLocalizacaoCliente = false;

    // } else if (this.router.url == '/localizacao-cliente') {
    //   this.menuNaoFaturamento = false;
    //   this.menuFinaneiro = false;
    //   this.menuNaoCarteira = false;
    //   this.menuNaoComercial = false;
    //   this.menuNaoTecnica = false;
    //   this.menuNaoCentral = false;
    //   // this.menuNaoVistoria = false;
    //   // this.menuNaoVistoriaManutencao = false;
    //   this.menuNaoLocalizacaoTecnico = false;
    //   // this.menuNaoLocalizacaoChamada = false;
    //   // this.menuNaoLocalizacaoClienteTecnico = false;
    //   // this.menuNaoLocalizacaoCliente = true;

    // }
  }

  Menu() {
    this.items = [
      {
        label: 'Faturamento',
        command: (event) => this.clickMenu(event),
        routerLink: 'faturamento',
        visible: this.currentUser.painel_faturamento,
        style: {
          'font-weight': 'bold',
          'background': this.menuNaoFaturamento ? '#b4b4b4' : 'white'
        },
      },
      {
        label: 'Financeiro',
        command: (event) => this.clickMenu(event),
        routerLink: 'financeiro',
        visible: this.currentUser.painel_financeiro,
        style: {
          'font-weight': 'bold',
          'background': this.menuFinaneiro ? '#b4b4b4' : 'white'
        },
      },
      {
        label: 'Carteira de Clientes',
        command: (event) => this.clickMenu(event),
        routerLink: 'carteira',
        visible: this.currentUser.painel_carteira,
        style: {
          'font-weight': 'bold',
          'background': this.menuNaoCarteira ? '#b4b4b4' : 'white'
        },
      },
      // {
      //   label: 'Vistoria Manutenção',
      //   command: (event) => this.clickMenu(event),
      //   routerLink: 'vistoria-manutencao',
      //   visible: this.currentUser.painel_vistoria,
      //   style: {
      //     'font-weight': 'bold',
      //     'background': this.menuNaoVistoriaManutencao ? '#b4b4b4' : 'white'
      //   },
      // },
      {
        label: 'Orçamentos',
        command: (event) => this.clickMenu(event),
        routerLink: 'comercial',
        visible: this.currentUser.painel_comercial,
        style: {
          'font-weight': 'bold',
          'background': this.menuNaoComercial ? '#b4b4b4' : 'white'
        },
      },
      // {
      //   label: 'Vistoria Elevador Novo',
      //   command: (event) => this.clickMenu(event),
      //   routerLink: 'vistoria',
      //   visible: this.currentUser.painel_vistoria_novo,
      //   style: {
      //     'font-weight': 'bold',
      //     'background': this.menuNaoVistoria ? '#b4b4b4' : 'white'
      //   },
      // },

      {
        label: 'Técnica',
        command: (event) => this.clickMenu(event),
        routerLink: 'tecnica',
        visible: this.currentUser.painel_tecnica,
        style: {
          'font-weight': 'bold',
          'background': this.menuNaoTecnica ? '#b4b4b4' : 'white'
        },
      },
      {
        label: 'Central de Atendimento',
        command: (event) => this.clickMenu(event),
        routerLink: 'central',
        visible: this.currentUser.painel_central,
        style: {
          'font-weight': 'bold',
          'background': this.menuNaoCentral ? '#b4b4b4' : 'white'
        },
      },
      {
        label: 'Localizacão Técnico',
        command: (event) => this.clickMenu(event),
        routerLink: 'localizacao-tecnico',
        visible: this.currentUser.painel_localizacao_tecnico,
        style: {
          'font-weight': 'bold',
          'background': this.menuNaoLocalizacaoTecnico ? '#b4b4b4' : 'white'
        },
      },
      // {
      //   label: 'Localização',
      //   style: {
      //     'font-weight': 'bold',
      //     'background': this.menuNaoLocalizacaoChamada ? '#b4b4b4' : 'white'
      //   },
      //   items: [
      //     {
      //       label: 'Localização Técnico',
      //       command: (event) => this.clickMenu(event),
      //       routerLink: 'localizacao-tecnico',
      //       visible: this.currentUser.painel_localizacao_tecnico,
      //       style: {
      //         'font-weight': 'bold',
      //         'background': this.menuNaoLocalizacaoTecnico ? '#b4b4b4' : 'white'
      //       },
      //     },
      //     {
      //       label: 'Localização Chamada',
      //       command: (event) => this.clickMenu(event),
      //       routerLink: 'localizacao-chamada',
      //       visible: this.currentUser.painel_localizacao_chamada,
      //       style: {
      //         'font-weight': 'bold',
      //         'background': this.menuNaoLocalizacaoChamada ? '#b4b4b4' : 'white'
      //       },
      //     },
      //     {
      //       label: 'Localização Técnico/Cliente',
      //       command: (event) => this.clickMenu(event),
      //       routerLink: 'localizacao-cliente-tecnico',
      //       visible: this.currentUser.painel_localizacao_cliente_tecnico,
      //       style: {
      //         'font-weight': 'bold',
      //         'background': this.menuNaoLocalizacaoClienteTecnico ? '#b4b4b4' : 'white'
      //       },
      //     },
      //     {
      //       label: 'Localização Cliente',
      //       command: (event) => this.clickMenu(event),
      //       routerLink: 'localizacao-cliente',
      //       visible: this.currentUser.painel_localizacao_cliente,
      //       style: {
      //         'font-weight': 'bold',
      //         'background': this.menuNaoLocalizacaoCliente ? '#b4b4b4' : 'white'
      //       },
      //     },
      //   ]
      // },

    ];

  }

  clickMenu(value): void {
    console.log(value)
    console.log(value.item.label)

    if (value.item.label == 'Faturamento') {
      this.menuNaoFaturamento = true;
      this.menuFinaneiro = false;
      this.menuNaoCarteira = false;
      this.menuNaoComercial = false;
      this.menuNaoTecnica = false;
      this.menuNaoCentral = false;
      // this.menuNaoVistoria = false;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = false;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    }
    else if (value.item.label == 'Financeiro') {
      this.menuNaoFaturamento = false;
      this.menuFinaneiro = true;
      this.menuNaoCarteira = false;
      this.menuNaoComercial = false;
      this.menuNaoTecnica = false;
      this.menuNaoCentral = false;
      // this.menuNaoVistoria = false;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = false;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    } else if (value.item.label == 'Carteira de Clientes') {
      this.menuNaoFaturamento = false;
      this.menuFinaneiro = false;
      this.menuNaoCarteira = true;
      this.menuNaoComercial = false;
      this.menuNaoTecnica = false;
      this.menuNaoCentral = false;
      // this.menuNaoVistoria = false;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = false;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    } else if (value.item.label == 'Orçamentos') {
      this.menuNaoFaturamento = false;
      this.menuFinaneiro = false;
      this.menuNaoCarteira = false;
      this.menuNaoComercial = true;
      this.menuNaoTecnica = false;
      this.menuNaoCentral = false;
      // this.menuNaoVistoria = false;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = false;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    } else if (value.item.label == 'Vistoria Elevador Novo') {
      this.menuNaoFaturamento = false;
      this.menuFinaneiro = false;
      this.menuNaoCarteira = false;
      this.menuNaoComercial = false;
      this.menuNaoTecnica = false;
      this.menuNaoCentral = false;
      // this.menuNaoVistoria = true;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = false;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    } else if (value.item.label == 'Técnica') {
      this.menuNaoFaturamento = false;
      this.menuFinaneiro = false;
      this.menuNaoCarteira = false;
      this.menuNaoComercial = false;
      this.menuNaoTecnica = true;
      this.menuNaoCentral = false;
      // this.menuNaoVistoria = false;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = false;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    } else if (value.item.label == 'Central de Atendimento') {
      this.menuNaoFaturamento = false;
      this.menuFinaneiro = false;
      this.menuNaoCarteira = false;
      this.menuNaoComercial = false;
      this.menuNaoTecnica = false;
      this.menuNaoCentral = true;
      // this.menuNaoVistoria = false;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = false;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    // } else if (value.item.label == 'Vistoria Manutenção') {
    //   this.menuNaoFaturamento = false;
    //   this.menuFinaneiro = false;
    //   this.menuNaoCarteira = false;
    //   this.menuNaoComercial = false;
    //   this.menuNaoTecnica = false;
    //   this.menuNaoCentral = false;
    //   this.menuNaoVistoria = false;
    //   this.menuNaoVistoriaManutencao = true;
    //   this.menuNaoLocalizacaoTecnico = false;
    //   this.menuNaoLocalizacaoChamada = false;
    //   this.menuNaoLocalizacaoClienteTecnico = false;
    //   this.menuNaoLocalizacaoCliente = false;
    } else if (value.item.label == 'Localizacão Técnico') {
      this.menuNaoFaturamento = false;
      this.menuFinaneiro = false;
      this.menuNaoCarteira = false;
      this.menuNaoComercial = false;
      this.menuNaoTecnica = false;
      this.menuNaoCentral = false;
      // this.menuNaoVistoria = false;
      // this.menuNaoVistoriaManutencao = false;
      this.menuNaoLocalizacaoTecnico = true;
      // this.menuNaoLocalizacaoChamada = false;
      // this.menuNaoLocalizacaoClienteTecnico = false;
      // this.menuNaoLocalizacaoCliente = false;
    // } else if (this.router.url == 'Localizacão Chamada') {
    //   this.menuNaoFaturamento = false;
    //   this.menuFinaneiro = false;
    //   this.menuNaoCarteira = false;
    //   this.menuNaoComercial = false;
    //   this.menuNaoTecnica = false;
    //   this.menuNaoCentral = false;
    //   this.menuNaoVistoria = false;
    //   this.menuNaoVistoriaManutencao = false;
    //   this.menuNaoLocalizacaoTecnico = false;
    //   this.menuNaoLocalizacaoChamada = true;
    //   this.menuNaoLocalizacaoClienteTecnico = false;
    //   this.menuNaoLocalizacaoCliente = false;
    // } else if (this.router.url == 'Localização Técnico/Cliente') {
    //   this.menuNaoFaturamento = false;
    //   this.menuFinaneiro = false;
    //   this.menuNaoCarteira = false;
    //   this.menuNaoComercial = false;
    //   this.menuNaoTecnica = false;
    //   this.menuNaoCentral = false;
    //   this.menuNaoVistoria = false;
    //   this.menuNaoVistoriaManutencao = false;
    //   this.menuNaoLocalizacaoTecnico = false;
    //   this.menuNaoLocalizacaoChamada = false;
    //   this.menuNaoLocalizacaoClienteTecnico = true;
    //   this.menuNaoLocalizacaoCliente = false;
    // } else if (this.router.url == 'Localização Cliente') {
    //   this.menuNaoFaturamento = false;
    //   this.menuFinaneiro = false;
    //   this.menuNaoCarteira = false;
    //   this.menuNaoComercial = false;
    //   this.menuNaoTecnica = false;
    //   this.menuNaoCentral = false;
    //   this.menuNaoVistoria = false;
    //   this.menuNaoVistoriaManutencao = false;
    //   this.menuNaoLocalizacaoTecnico = false;
    //   this.menuNaoLocalizacaoChamada = false;
    //   this.menuNaoLocalizacaoClienteTecnico = false;
    //   this.menuNaoLocalizacaoCliente = true;
    }
    this.Menu();
  }

  logout() {
    this.service.logout();
    this.router.navigate(['/login']);
  }
}